// All dummy data for the dashboard
export const overviewStats = {
  activeUsers: { value: 1523, change: 12.5, trend: "up" },
  totalConversations: { value: 4892, change: 8.3, trend: "up" },
  totalCost: { value: 3.21, change: 9.2, trend: "up" },
  totalRequests: { value: 18934, change: 15.2, trend: "up" },
  avgResponseTime: { value: 1.64, change: 5.1, trend: "down" },
};

export const dailyActivityData = [
  { date: "Jan 1", requests: 2145, users: 198 },
  { date: "Jan 2", requests: 2489, users: 234 },
  { date: "Jan 3", requests: 2312, users: 212 },
  { date: "Jan 4", requests: 2678, users: 245 },
  { date: "Jan 5", requests: 2891, users: 267 },
  { date: "Jan 6", requests: 2734, users: 251 },
  { date: "Jan 7", requests: 2685, users: 246 },
];

export const summaryMetrics = {
  totalTokens: 4930000,
  totalCost: 3.21,
  successRate: 98.7,
};

export const tokenUsageStats = {
  totalTokens: 4930000,
  inputTokens: 1820000,
  outputTokens: 3110000,
  totalCost: 3.21,
  costPerRequest: 0.00017,
  avgTokensPerRequest: 260,
  monthlyProjection: 13.75,
  budgetLimit: 100,
  budgetUsed: 13.8,
};

export const tokenTrendData = [
  { date: "Jan 1", tokens: 558000, cost: 0.342 },
  { date: "Jan 2", tokens: 647360, cost: 0.397 },
  { date: "Jan 3", tokens: 601120, cost: 0.369 },
  { date: "Jan 4", tokens: 696280, cost: 0.427 },
  { date: "Jan 5", tokens: 751660, cost: 0.461 },
  { date: "Jan 6", tokens: 711040, cost: 0.436 },
  { date: "Jan 7", tokens: 698100, cost: 0.428 },
];

export const userTokenConsumption = [
  {
    userId: "user_abc123",
    conversations: 15,
    totalRequests: 87,
    tokensUsed: 25430,
    cost: 0.0156,
  },
  {
    userId: "user_xyz789",
    conversations: 12,
    totalRequests: 68,
    tokensUsed: 19842,
    cost: 0.0121,
  },
  {
    userId: "user_def456",
    conversations: 18,
    totalRequests: 102,
    tokensUsed: 28934,
    cost: 0.0178,
  },
];

export const userBehaviorStats = {
  newUsers: 342,
  returningUsers: 1181,
  retentionRate: 77.5,
  avgSessionDuration: "4m 32s",
};

export const dailyUsersData = [
  { date: "Jan 1", users: 198 },
  { date: "Jan 2", users: 234 },
  { date: "Jan 3", users: 212 },
  { date: "Jan 4", users: 245 },
  { date: "Jan 5", users: 267 },
  { date: "Jan 6", users: 251 },
  { date: "Jan 7", users: 246 },
];

export const conversationLengthData = [
  { category: "1-2 messages", count: 734 },
  { category: "3-5 messages", count: 1565 },
  { category: "6-10 messages", count: 1370 },
  { category: "11-20 messages", count: 881 },
  { category: "20+ messages", count: 342 },
];

export const peakHoursData = [
  { hour: "9AM", requests: 428 },
  { hour: "10AM", requests: 512 },
  { hour: "11AM", requests: 489 },
  { hour: "12PM", requests: 378 },
  { hour: "1PM", requests: 445 },
  { hour: "2PM", requests: 589 },
  { hour: "3PM", requests: 567 },
  { hour: "4PM", requests: 523 },
];

export const userEngagementMetrics = [
  {
    metric: "Avg Messages per Conversation",
    value: "6.4",
    change: "+8.5%",
    status: "Good",
  },
  {
    metric: "Conversation Completion Rate",
    value: "88%",
    change: "+3.2%",
    status: "Excellent",
  },
  { metric: "Drop-off Rate", value: "12%", change: "+1.5%", status: "Monitor" },
];

export const intentDistributionData = [
  { name: "Performance Query", value: 1234, color: "#9333ea" },
  { name: "Information Request", value: 1108, color: "#3b82f6" },
  { name: "Comparison", value: 892, color: "#f59e0b" },
  { name: "Investment Query", value: 756, color: "#10b981" },
  { name: "Data Query", value: 623, color: "#06b6d4" },
];

export const intentMetrics = [
  {
    intent: "Performance Query",
    count: 1234,
    percentage: 25.2,
    avgTokens: 287,
    avgCost: 0.00018,
    successRate: 94,
  },
  {
    intent: "Information Request",
    count: 1108,
    percentage: 22.6,
    avgTokens: 245,
    avgCost: 0.00014,
    successRate: 96,
  },
  {
    intent: "Comparison",
    count: 892,
    percentage: 18.2,
    avgTokens: 312,
    avgCost: 0.00021,
    successRate: 92,
  },
];

export const topQueries = [
  {
    rank: 1,
    query: "What is PMS?",
    frequency: 456,
    intent: "Information Request",
    avgResponseTime: "1.2s",
  },
  {
    rank: 2,
    query: "Show me top performing PMS",
    frequency: 389,
    intent: "Performance Query",
    avgResponseTime: "1.8s",
  },
  {
    rank: 3,
    query: "Minimum investment for AIF",
    frequency: 342,
    intent: "Investment Query",
    avgResponseTime: "1.1s",
  },
];

export const performanceStats = {
  avgResponseTime: 1.64,
  p95ResponseTime: 3.42,
  successRate: 98.7,
  errorRate: 1.3,
  totalRequests: 18934,
  successfulRequests: 18696,
  failedRequests: 238,
};

export const responseTimeDistribution = [
  { range: "<1s", count: 3456 },
  { range: "1-2s", count: 8923 },
  { range: "2-3s", count: 4567 },
  { range: "3-4s", count: 1234 },
  { range: "4-5s", count: 567 },
  { range: ">5s", count: 187 },
];

export const responseTimeByIntent = [
  {
    intent: "Information Request",
    avgResponseTime: 1.42,
    min: 0.8,
    max: 4.2,
    count: 1108,
  },
  {
    intent: "Performance Query",
    avgResponseTime: 2.13,
    min: 1.2,
    max: 7.8,
    count: 1234,
  },
];

export const errorAnalysisData = [
  { type: "Timeout", count: 142, color: "#ef4444" },
  { type: "API Limit", count: 56, color: "#f97316" },
  { type: "Invalid Request", count: 40, color: "#f59e0b" },
];

export const recentConversations = [
  {
    sessionId: "ses_a1b2c3",
    userId: "user_abc123",
    startTime: "2024-01-07 14:32",
    messages: 8,
    tokens: 1542,
    cost: 0.00094,
    duration: "4m 15s",
    status: "Complete",
  },
  {
    sessionId: "ses_d4e5f6",
    userId: "user_xyz789",
    startTime: "2024-01-07 14:28",
    messages: 12,
    tokens: 2234,
    cost: 0.00137,
    duration: "6m 42s",
    status: "Complete",
  },
];

export const hourlyBreakdown = [
  {
    hour: "09:00-10:00",
    requests: 428,
    tokens: 112345,
    cost: 0.069,
    avgResponseTime: "1.52s",
    errorRate: "0.9%",
  },
  {
    hour: "10:00-11:00",
    requests: 512,
    tokens: 134876,
    cost: 0.083,
    avgResponseTime: "1.48s",
    errorRate: "1.1%",
  },
];
